
import TextTypeWriterAnimation from "../../../../../../../shared/src/ranj/app/ui/animation/typewriters/TextTypeWriterAnimation";
import BalloonView from "./BalloonView";

export default class InfoBalloonView extends BalloonView {

    constructor(target) {
        super(target);
        
        this._bgHeightOrig = this._target.bg.getTransformedBounds().height;
        this._margin = this._bgHeightOrig - this.getTextHeight();
        this._scaleOrig = this._target.bg.scaleY;
    }

    setText(text, animate) {
        if (this._textAnim) {
            this._textAnim.forceFinish();
        }

        if (animate) {
            const target = this._target;
            target.alpha = 0;
            const duration = 300 / this._speedFactor;
            createjs.Tween.get(target).to({ alpha: 1 }, duration, createjs.Ease.quadOut);
        }
        //fit to content
        this._textfield.text = text;
        const textHeight = this.getTextHeight();
        this._target.bg.scaleY = this._scaleOrig * (textHeight + this._margin) / this._bgHeightOrig;
        //typewriter
        this._textfield.text = "";
        const duration = text.length / 80 / this._speedFactor;
        this._textAnim = TextTypeWriterAnimation.animate(this._textfield, text, duration, 0, createjs.Ease.linear);
    }

    getTextHeight() {
        return this._textfield.getMeasuredHeight() ;//* this._textfield.scaleY;
    }

}
